export default __webpack_public_path__ + "static/media/bg-systemes-information.174c6416.webp";